<template>
  <div class="product-header-container">
    <div class="smart-header">
      <Header
        theme="light"
        :showBorder="true"
        :backgroundColor="'#ffffff'"
        :iconColor="'black'"
        :smallLogoWidth="smallLogoWidth"
        :smallLogoHeight="smallLogoHeight"
        :borderVisible="borderVisible"
        @menu-open="onMenuOpen"
        @menu-close="onMenuClose"
      />
    </div>

    <div class="content-wrapper font-apercu-medium">
      <div class="sticky-bar">
        <div class="header-row">
          <h1 class="page-title font-apercu-medium">{{ productName }}</h1>
          <span class="product-count">{{ totalCount }} Products</span>
        </div>
      </div>
      <p class="page-description">
        {{ productDescription }}
      </p>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'

export default {
  name: 'ProductHeader',
  components: {
    Header
  },
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    productName: {
      type: String,
      default: 'ALL Products'
    },
    productDescription: {
      type: String,
      default: 'All Product Displays'
    },
    smallLogoWidth: {
      type: Number,
      default: 118
    },
    smallLogoHeight: {
      type: Number,
      default: 13
    },
    borderVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuOpen: false,
    }
  },
  methods: {
    onMenuOpen() {
      this.menuOpen = true
      this.$emit('menu-open')
    },
    onMenuClose() {
      this.menuOpen = false
      this.$emit('menu-close')
    }
  }
}
</script>

<style scoped>
.product-header-container {
  width: 100%;
  position: relative;
  background-color: #FBFBFB;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  border-bottom: 1rem solid rgba(0,0,0,1);
}

.smart-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #ffffff;
}

.content-wrapper {
  padding: 275rem 40rem 40rem 40rem;
  max-width: 100%;
  margin: 0 auto;
}

.sticky-bar {
  padding-right: 23rem;
  padding-left: 23rem;
  background-color: #FBFBFB;
  padding-bottom: 20rem;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

.page-title {
  font-size: 24rem;
  font-weight: 500;
  color: #000;
  margin: 0;
}

.product-count {
  font-size: 16rem;
  font-weight: 500;
  color: #000;
}

.page-description {
  font-size: 16rem;
  color: #000;
  font-weight: 500;
  max-width: 600rem;
  margin: 0;
  padding-left: 23rem;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 215rem 20rem 30rem 20rem;
  }
  .header-row {
    flex-direction: column;
    gap: 10rem;
  }
  .product-count {
    order: -1;
  }
}
</style>